import { Modal, Box, Typography, Button, DialogContent, DialogTitle, DialogActions } from "@mui/material";
// import CircularProgress from '@mui/material/CircularProgress';
import styles from "./emailBindModal.module.scss";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import EmailSvg from "@/app/csr-src/assets/icons/email.svg";

interface EmailBindModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onBindEmail: () => void;
  onRemindLater: () => void;
  onCloseParent:() => void;
  tipData?: {
    title: string;
    subTitle: string;
    btn: string;
    subBtn: string;
  };
}

export const EmailBindModal = ({
  open,
  onClose,
  onBindEmail,
  onRemindLater,
  onCloseParent,
  tipData = {
    title: "Get order updates via email from us",
    subTitle: "Bind your email to get order confirmations, shipping updates, and exclusive offers",
    btn: "Bind Email",
    subBtn: "Remind me later",
  },
}: EmailBindModalProps) => {
  return (
    <UKDialog
      open={open}
      onClose={onCloseParent}
      showCloseBtn={true}
      sx={{
        "& .MuiDialog-paper": {
          width: "426px", // 设置自定义宽度
          minWidth: "426px",
          minHeight: "342px",
        },
      }}
    >
      <DialogContent>
        <div className={styles.modalContent}>
          <div className={styles.modalSvg}>
            <EmailSvg />
          </div>
          <div className={styles.modalText}>
            <div className={styles.modalTitle}>{tipData.title || ''}</div>
            <div className={styles.modalBody}>{tipData.subTitle || ''}</div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onRemindLater}>
          {tipData.subBtn || "Remind me later"}
        </Button>
        <Button variant="contained" onClick={onBindEmail}>
          {tipData.btn || "Bind email"}
        </Button>
      </DialogActions>
    </UKDialog>
    
  );
};
